import { Navigate, Route, Routes } from 'react-router-dom';
import { Navegacao } from './componentes/layout/Navegacao.js';
import { BarraTopo } from './componentes/layout/BarraTopo.js';
import { MeuTrabalho } from './paginas/MeuTrabalho.js';
import { Intake } from './paginas/Intake.js';
import { Blueprints } from './paginas/Blueprints.js';
import { BlueprintDetalhe } from './paginas/BlueprintDetalhe.js';
import { Workload } from './paginas/Workload.js';
import { Projetos } from './paginas/Projetos.js';
import { ProjetoDetalhe } from './paginas/ProjetoDetalhe.js';
import { AtividadesFase } from './paginas/AtividadesFase.js';
import { Raid } from './paginas/Raid.js';
import { Programas } from './paginas/Programas.js';
import { ProgramaDetalhe } from './paginas/ProgramaDetalhe.js';
import { PortfolioPagina } from './paginas/Portfolio.js';
import { Scorecards } from './paginas/Scorecards.js';
import { PainelSemanalExecutor } from './componentes/layout/PainelSemanalExecutor.js';

// SPEC-UX-COMPASSO.md §2.2 — rotas correspondem 1:1 à árvore de navegação.
export function App() {
  return (
    <div className="flex h-screen">
      <Navegacao />
      <div className="flex flex-1 flex-col overflow-hidden">
        <BarraTopo />
        <main className="flex-1 overflow-auto bg-base-100">
          <Routes>
            <Route path="/" element={<Navigate to="/meu-trabalho" replace />} />
            <Route path="/meu-trabalho" element={<MeuTrabalho />} />
            <Route path="/intake" element={<Intake />} />
            <Route path="/projetos" element={<Projetos />} />
            <Route path="/projetos/:id" element={<ProjetoDetalhe />} />
            <Route path="/fases/:faseId/atividades" element={<AtividadesFase />} />
            <Route path="/programas" element={<Programas />} />
            <Route path="/programas/:id" element={<ProgramaDetalhe />} />
            <Route path="/portfolio" element={<PortfolioPagina />} />
            <Route path="/scorecards" element={<Scorecards />} />
            <Route path="/workload" element={<Workload />} />
            <Route path="/raid" element={<Raid />} />
            <Route path="/blueprints" element={<Blueprints />} />
            <Route path="/blueprints/:id" element={<BlueprintDetalhe />} />
          </Routes>
        </main>
      </div>
      <PainelSemanalExecutor />
    </div>
  );
}
